require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/web.dom-collections.for-each");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/dialog/style", "vant/es/dialog", "axios", "@/config/index"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/dialog/style"), require("vant/es/dialog"), require("axios"), require("@/config/index"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.dialog, global.axios, global.index);
    global.ajax = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _dialog, _axios, _index) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.netError = void 0;
  _dialog = _interopRequireDefault(_dialog);
  _axios = _interopRequireDefault(_axios);
  var isErrDialog = false; // 网络异常状态：banner 开启后错误不弹窗

  var netError = {
    // 是否启用提示条模式
    banner: false,
    // 当前是否网络异常
    value: false,
    // 状态变化监听
    listeners: []
  }; // 更新状态并通知监听

  _exports.netError = netError;

  var setNetError = function setNetError(value) {
    if (!netError.banner || netError.value === value) return;
    netError.value = value;
    netError.listeners.forEach(function (fn) {
      return fn(value);
    });
  }; // create an axios instance


  var service = _axios.default.create({
    baseURL: _index.base.BASE_URL,
    // request timeout
    timeout: 30000,
    // 请求失败重试
    retry: _index.base.RETRY_COUNT,
    // 重试间隔时间
    retryDelay: _index.base.RETRY_DELAY
  }); // request interceptor


  service.interceptors.request.use(function (config) {
    // if (store.getters.token) {
    //     config.headers['access-token'] = getToken();
    // }
    config.type && (config.method = config.type);
    return config;
  }, function (error) {
    console.log(error);
    return Promise.reject(error);
  }); // response interceptor

  service.interceptors.response.use(function (response) {
    var res = response.data; // 收到响应即视为恢复

    setNetError(false);

    if (res.code !== 1 && !response.config.except) {
      _dialog.default.alert({
        title: '提示',
        message: res.message ? res.message.sqlMessage || res.message : '网络堵塞！请稍后再试~'
      });

      return Promise.reject(res.message || 'Error');
    } else {
      if (isErrDialog) {
        _dialog.default.close();

        isErrDialog = false;
      }

      return res;
    }
  }, function (error) {
    // 请求超时时隔10秒再次重试1次
    if (error.message.indexOf('timeout') > -1) {
      var config = error.config;

      if (!config || !config.retry) {
        return Promise.reject(error);
      }

      config.__retryCount = config.__retryCount || 0;

      if (config.__retryCount >= config.retry) {
        // 提示条模式：超时不弹窗
        if (netError.banner) {
          setNetError(true);
        } else {
          _dialog.default.alert({
            message: error.message,
            title: 'timeout'
          });
        }

        return Promise.reject(error);
      }

      config.__retryCount += 1;
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        }, config.retryDelay || 1);
      });
      return backoff.then(function () {
        return service(config);
      });
    } else {
      console.log('err' + error); // for debug
      // 提示条模式：不弹窗

      if (netError.banner) {
        setNetError(true);
      } else {
        _dialog.default.alert({
          message: JSON.stringify(error),
          title: '提示'
        });

        isErrDialog = true;
      }
    }
  });
  var _default = service;
  _exports.default = _default;
});